import { Button, TextField } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import ReduxLanguage from '../ReduxLanguage';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    maxWidth: 480,
    marginBottom: 24,
  },
  inputTitle: {
    marginTop: 0,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  description: {
    marginBottom: 16,
    color: 'gray',
  },
  errorText: {
    color: 'red',
    marginTop: 8,
  },
});

export interface ITextParamConfigFormState {
  value: string;
  valueError: boolean;
}

export interface ITextParamConfigFormProps extends WithStyles<typeof styles> {
  titleLanguageKey: string;
  descriptionLanguageKey: string;
  initialValue: string;
  hasExistingConfig: boolean;
  onSave: (value: string) => void;
  isSaving: boolean;
}

class TextParamConfigForm extends React.Component<ITextParamConfigFormProps, ITextParamConfigFormState> {

  constructor(props: ITextParamConfigFormProps) {
    super(props);
    this.state = {
      value: props.initialValue || '',
      valueError: false,
    };
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps: ITextParamConfigFormProps) {
    const { initialValue } = this.props;
    if (prevProps.initialValue !== initialValue) {
      this.setState({ value: initialValue || '', valueError: false });
    }
  }

  onChangeValue(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ value, valueError: !value.trim() });
  }

  canSubmitForm() {
    const { value, valueError } = this.state;
    const { initialValue, isSaving, hasExistingConfig } = this.props;
    const isValid = !isSaving && !valueError && !!value.trim();
    if (!hasExistingConfig) {
      return isValid;
    }
    return isValid && value !== initialValue;
  }

  onSubmit() {
    const { onSave } = this.props;
    const { value } = this.state;
    if (this.canSubmitForm()) {
      onSave(value.trim());
    }
  }

  render() {
    const { classes, isSaving, titleLanguageKey, descriptionLanguageKey } = this.props;
    const { value, valueError } = this.state;

    return (
      <div className={classes.container}>
        <h3 className={classes.inputTitle}>
          <ReduxLanguage languageKey={titleLanguageKey} />
        </h3>
        <p className={classes.description}>
          <ReduxLanguage languageKey={descriptionLanguageKey} />
        </p>
        <TextField
          value={value}
          onChange={this.onChangeValue}
          fullWidth
          variant="outlined"
        />
        {valueError && (
          <p className={classes.errorText}>
            <ReduxLanguage languageKey="settings.invalidTextValue" />
          </p>
        )}
        <Button
          style={{ marginTop: 20 }}
          variant="contained"
          color="primary"
          disabled={!this.canSubmitForm() || isSaving}
          onClick={this.onSubmit}
        >
          <ReduxLanguage languageKey="settings.save" />
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(TextParamConfigForm);
